module.exports = __webpack_public_path__ + "img/17.0c29dda1.png";